import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import styled from "styled-components"
import {Row, Col} from "react-bootstrap"
import padding from "@irati/ui/src/global/padding"

import withBranding from "@irati/brand/withBranding"
import {Banner} from "@irati/ui/src/Layout"
import Card from "@irati/ui/src/Layout/Card"
import {H2, H4} from "@irati/ui/src/Typography/Heading"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import Input from "@irati/ui/src/FormItem/Input"
import History from "@irati/utils/history"
import Form from "@irati/ui/src/Form"
import Loading from "@irati/ui/src/Loading"
import {Firstname, Lastname, Email} from "@irati-web/fields/user"

import {CODE, NONE, WELCOME_MESSAGE} from "@irati-web/admin/src/constants/selfSignUp"
import {FormattedMessage, injectIntl, LangLoader} from "@irati/utils/lang"
import Validation from "@irati/utils/validation"
import {PLATFORM} from "@irati-web/app/src/routeConfig"
import {FIELDS} from "@irati-web/fields/index"
import selfSignUpService from "../../services/selfSignUp"

const StyledCard = styled(Card)`
  padding: 60px 100px;
  max-width: 800px;
  margin: 120px auto 0;
`

const Img = styled.img`
  max-width: 100%;
  padding-bottom: ${padding.large};
`

const secretCodeSchema = Validation.string().min(5, "platform.selfSignUp.secretCodeSchema.min")

class SelfSignUp extends Component {
  static propTypes = {
    userTenant: PropTypes.object.isRequired,
    formatMessage: PropTypes.func.isRequired,
    branding: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      id: null,
      method: null,
      keys: null,
      user: {
        firstname: "",
        lastname: null,
        email: ""
      },
      secretCode: "",
      welcomeMessage: this.props.formatMessage({id: WELCOME_MESSAGE}),
      saving: null
    }
  }

  componentDidMount() {
    selfSignUpService.getSelfSignupByTenantUnAuth(this.props.userTenant).then((data) => {
      if (data.method === NONE) {
        this.redirectToLogin()
      }
      if (data.uuid) {
        this.setState({
          id: data.uuid,
          method: data.method,
          welcomeMessage: data.welcomeMessage || this.props.formatMessage({id: WELCOME_MESSAGE})
        })
      } else {
        this.redirectToLogin()
      }
    }).catch(() => {
      this.redirectToLogin()
    })
  }

  redirectToLogin = () => {
    History.push("/welcome/login")
  }

  onChange = (label, value) => {
    this.setState({
      [label]: value,
      saving: null
    })
  }

  onChangeUser = (label, value) => {
    this.setState(({user}) => ({
      user: {
        ...user,
        [label]: value
      },
      saving: null
    }))
  }

  onSubmit = () => {
    const {id, user, secretCode} = this.state

    const secret = this.state.method === CODE ? secretCode : null
    const saving = selfSignUpService.sendCreateUserRequest(id, secret, user).then(() => {
      History.push({
        pathname: "welcome/login/check-email",
        onboarding: true,
        email: user.user
      })
    })
    this.setState({saving})
  }

  render() {
    const {user, secretCode, welcomeMessage, saving} = this.state
    const {formatMessage, branding} = this.props
    return (
      <LangLoader buckets={[PLATFORM, FIELDS]}>
        <Banner />
        <Row>
          <Col md={12}>
            <StyledCard>
              <Img src={branding.businessLogoUrl} />
              <H2 base>
                <FormattedMessage id="platform.selfSignUp.heading" />
              </H2>
              {welcomeMessage.split("\n").map((sentence) => (
                <H4 small>{sentence}</H4>
              ))}
              <Form>
                <Row>
                  <Col xs={6}>
                    <Firstname value={user.firstname} onChange={(value) => this.onChangeUser("firstname", value)} />
                  </Col>
                  <Col xs={6}>
                    <Lastname value={user.lastname} onChange={(value) => this.onChangeUser("lastname", value)} />
                  </Col>
                </Row>
                <Email value={user.email} onChange={(value) => this.onChangeUser("email", value)} />
                {this.state.method === CODE && (
                  <Input
                    name="secretCode"
                    label={formatMessage({id: "platform.selfSignUp.fields.secretCode.label"})}
                    value={secretCode}
                    onChange={(value) => this.onChange("secretCode", value)}
                    validation={secretCodeSchema} />
                )}
                <ValidationButton primary large full onClick={this.onSubmit} load={saving}>
                  <FormattedMessage id="platform.selfSignUp.validation.button" />
                </ValidationButton>
                <Loading load={saving} useLoader={false} />
              </Form>
            </StyledCard>
          </Col>
        </Row>
      </LangLoader>
    )
  }
}

const mapStateToProps = (state) => ({
  userTenant: state.auth.userTenant
})

export default injectIntl(connect(mapStateToProps)(withBranding(SelfSignUp)))
